/* ZOOPLICITY POMAGA — native Theme Editor surfaces + cart estimate. Test theme only. */
(function () {
  'use strict';

  const HELP_URL = '/pages/zooplicity-pomaga';
  let refreshTimer;

  function fixLegacyHelpLinks() {
    document.querySelectorAll('a[href="/pages/pomagamy"], a[href$="/pages/pomagamy"]').forEach((link) => {
      link.setAttribute('href', HELP_URL);
    });
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: currency || 'PLN'
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' zł';
    }
  }

  async function refreshCartHelp() {
    const boxes = Array.from(document.querySelectorAll('[data-zp-help-cart-native]'));
    if (!boxes.length) return;

    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;

      const cart = await response.json();
      let help = 0;
      let hasRegular = false;

      (cart.items || []).forEach((item) => {
        const regular = Boolean(item.selling_plan_allocation);
        if (regular) hasRegular = true;
        help += (Number(item.final_line_price) || 0) * (regular ? 0.015 : 0.0075);
      });

      boxes.forEach((box) => {
        const amount = box.querySelector('[data-zp-help-cart-amount]');
        const mode = box.querySelector('[data-zp-help-cart-mode]');
        if (amount) amount.textContent = money(Math.round(help), cart.currency || 'PLN');
        if (mode) {
          mode.textContent = hasRegular
            ? (box.dataset.modeRegular || 'Koszyk zawiera Regularną Paczkę — dla tych pozycji naliczamy 1,5%.')
            : (box.dataset.modeOne || 'Dla zakupów jednorazowych naliczamy 0,75%.');
        }
      });
    } catch (error) {
      /* Pomoc w koszyku jest informacyjna — awaria estymatora nie może blokować zakupów. */
    }
  }

  function scheduleCartRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCartHelp, 420);
  }

  function init() {
    fixLegacyHelpLinks();
    refreshCartHelp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    fixLegacyHelpLinks();
    scheduleCartRefresh();
  });
  document.addEventListener('change', scheduleCartRefresh, true);
  document.addEventListener('click', scheduleCartRefresh, true);
  ['cart:update', 'cart:change', 'cart:refresh'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleCartRefresh);
  });
})();
